/* BEGIN TFX_COLLECTION_OVERLAY_REFRESH
   Objective: centralize overlay/product-card helpers for collection + featured-collection TFX contexts.
   Scope: [data-tfx-collection-section], [data-tfx-fc-section], related-products overlay add-to-cart.
   Rollback: remove this file + script tag include in layout/theme.liquid, then restore section-local JS blocks.
*/
(function() {
  if (window.__tfxCollectionOverlayRefreshBooted) { return; }
  window.__tfxCollectionOverlayRefreshBooted = true;

  var scheduleReinitFrame = null;
  var scheduleReinitTimer = null;
  var overlayRefreshState = window.__tfxCollectionOverlayRefreshState || {
    observer: null,
    collectionListenersBound: false,
    featuredListenersBound: false,
    featuredResizeListenerBound: false,
    collectionEditorReinitHandler: null
  };
  window.__tfxCollectionOverlayRefreshState = overlayRefreshState;

  function reinitCollectionOverlays() {
    if (typeof window.tfxInitCollectionRelatedPresentation !== 'function') { return; }
    document.querySelectorAll('[data-tfx-collection-section]').forEach(function(section) {
      var id = section.getAttribute('data-section-id');
      if (id) {
        window.tfxInitCollectionRelatedPresentation(id);
      }
    });
  }

  function findFeaturedCollectionSection(sectionId) {
    if (!sectionId) { return null; }
    return document.querySelector('[data-section-id="' + sectionId + '"][data-tfx-fc-section]');
  }

  function syncFeaturedCollectionCentering(sectionElement) {
    if (!sectionElement) { return; }

    sectionElement.querySelectorAll('[data-tfx-fc-overlay-root].slider').forEach(function(overlayRoot) {
      var carouselGrid = overlayRoot.querySelector('.product-grid.product-grid--carousel');
      if (!carouselGrid) {
        overlayRoot.classList.remove('tfx-fc-underflow');
        return;
      }

      if (!window.matchMedia('(min-width: 1000px)').matches) {
        overlayRoot.classList.remove('tfx-fc-underflow');
        return;
      }

      var hasUnderflow = carouselGrid.scrollWidth <= (overlayRoot.clientWidth + 1);
      overlayRoot.classList.toggle('tfx-fc-underflow', hasUnderflow);
    });
  }

  function syncAllFeaturedCollectionCentering() {
    document.querySelectorAll('[data-tfx-fc-section]').forEach(function(sectionNode) {
      syncFeaturedCollectionCentering(sectionNode);
    });
  }

  function initFeaturedCollectionSection(sectionElement) {
    if (!sectionElement) { return; }

    if (sectionElement.dataset.tfxFcMobileClickPriorityBound !== 'true' && !sectionElement.querySelector('carousel-slider')) {
      var stopSwipeOnNarrow = function(event) {
        var imageContainer = event.target.closest('.image-cont--with-secondary-image');
        if (!imageContainer || !sectionElement.contains(imageContainer)) { return; }
        if (!imageContainer.closest('[data-tfx-fc-overlay-root]')) { return; }
        event.stopPropagation();
      };

      sectionElement.addEventListener('touchstart', stopSwipeOnNarrow, { capture: true, passive: true });
      sectionElement.addEventListener('touchmove', stopSwipeOnNarrow, { capture: true, passive: true });
      sectionElement.dataset.tfxFcMobileClickPriorityBound = 'true';
    }

    if (sectionElement.dataset.tfxFcOverlayInit !== 'true') {
      sectionElement.addEventListener('click', function(event) {
        var addButton = event.target.closest('[data-tfx-rp-add]');
        if (!addButton || !sectionElement.contains(addButton)) { return; }

        var overlayRoot = addButton.closest('[data-tfx-fc-overlay-root]');
        if (!overlayRoot || !sectionElement.contains(overlayRoot)) { return; }

        if (typeof window.tfxOverlayAddToCart !== 'function') {
          var productBlock = addButton.closest('.product-block');
          var productLink = productBlock ? productBlock.querySelector('.product-link[href]') : null;
          if (productLink) {
            window.location.href = productLink.getAttribute('href');
          }
          return;
        }

        event.preventDefault();
        window.tfxOverlayAddToCart(addButton);
      });

      sectionElement.dataset.tfxFcOverlayInit = 'true';
    }

    syncFeaturedCollectionCentering(sectionElement);
    requestAnimationFrame(function() {
      syncFeaturedCollectionCentering(sectionElement);
    });
  }

  window.tfxInitFeaturedCollectionPresentation = function(sectionId) {
    var sectionElement = findFeaturedCollectionSection(sectionId);
    if (!sectionElement) { return; }
    initFeaturedCollectionSection(sectionElement);
  };

  function reinitFeaturedCollectionPresentations() {
    document.querySelectorAll('[data-tfx-fc-section]').forEach(function(sectionNode) {
      initFeaturedCollectionSection(sectionNode);
    });
  }

  function reinitOverlays() {
    reinitCollectionOverlays();
    reinitFeaturedCollectionPresentations();
  }

  var OBSERVED_CONTEXT_SELECTOR = '[data-tfx-collection-section], [data-tfx-fc-section]';
  var OBSERVED_MUTATION_SELECTOR = '[data-ajax-container], [data-tfx-collection-overlay-root], [data-tfx-fc-overlay-root], [data-tfx-fc-dynamic-related-content], .product-grid, .product-block';

  function pushUniqueElement(list, element) {
    if (!element || element.nodeType !== 1) { return; }
    if (list.indexOf(element) !== -1) { return; }
    list.push(element);
  }

  function getCollectionObserverTargets() {
    var targets = [];
    document.querySelectorAll(OBSERVED_CONTEXT_SELECTOR).forEach(function(sectionNode) {
      pushUniqueElement(targets, sectionNode);
    });

    return targets;
  }

  function mutationTouchesRelevantZone(mutation) {
    if (!mutation || !mutation.addedNodes || mutation.addedNodes.length === 0) { return false; }

    var mutationTarget = mutation.target;
    if (mutationTarget && mutationTarget.nodeType === 1 && mutationTarget.closest && mutationTarget.closest(OBSERVED_CONTEXT_SELECTOR)) {
      return true;
    }

    for (var i = 0; i < mutation.addedNodes.length; i += 1) {
      var node = mutation.addedNodes[i];
      if (!node || node.nodeType !== 1) { continue; }
      if ((node.matches && node.matches(OBSERVED_MUTATION_SELECTOR)) || (node.querySelector && node.querySelector(OBSERVED_MUTATION_SELECTOR))) {
        return true;
      }
    }

    return false;
  }

  function debounceReinit() {
    if (scheduleReinitTimer !== null) { return; }

    // Coalesce mutation bursts during filters/AJAX updates before a single reinit pass.
    scheduleReinitTimer = window.setTimeout(function() {
      scheduleReinitTimer = null;
      if (scheduleReinitFrame !== null) { return; }

      scheduleReinitFrame = requestAnimationFrame(function() {
        scheduleReinitFrame = null;
        reinitOverlays();
      });
    }, 120);
  }

  function isCollectionContext() {
    if (!document.body) { return false; }
    if (document.body.classList.contains('template-collection')) { return true; }
    return !!document.querySelector('[data-tfx-collection-section]');
  }

  function addOverlayItemToCart(addButton) {
    if (!addButton) { return Promise.resolve(false); }
    if (!window.theme || !theme.routes || !theme.routes.cartAdd) { return Promise.resolve(false); }
    if (addButton.disabled || addButton.getAttribute('aria-disabled') === 'true') { return Promise.resolve(false); }

    var variantId = addButton.getAttribute('data-variant-id');
    if (!variantId) { return Promise.resolve(false); }

    addButton.setAttribute('aria-disabled', 'true');
    addButton.classList.add('is-loading');

    var releaseButton = function() {
      setTimeout(function() {
        addButton.classList.remove('is-loading');
        addButton.classList.remove('is-success');
        addButton.removeAttribute('aria-disabled');
      }, 1400);
    };

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    return fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function(response) {
        return response.json().then(function(data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function(result) {
        if (!result.ok || result.data.status) {
          throw new Error((result.data && (result.data.description || result.data.message)) || 'Add to cart failed');
        }

        addButton.classList.add('is-success');
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
        document.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: {
            variantId: variantId
          }
        }));

        if (theme.settings.afterAddToCart === 'page') {
          setTimeout(function() {
            window.location.href = theme.routes.cart;
          }, 300);
        } else if (theme.settings.afterAddToCart === 'notification') {
          var notificationTemplate = document.getElementById('AddedNotification');
          if (notificationTemplate && notificationTemplate.content && notificationTemplate.content.firstElementChild) {
            var notification = notificationTemplate.content.firstElementChild.cloneNode(true);
            notification.dataset.productTitle = addButton.getAttribute('data-product-title') || '';
            var notificationContainer = document.querySelector('.pageheader--sticky') || document.body;
            notificationContainer.appendChild(notification);
          }
        } else if (theme.settings.afterAddToCart === 'drawer') {
          var cartDrawer = document.querySelector('.js-cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open(addButton);
          }
        }

        return true;
      })
      .catch(function(error) {
        document.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error && error.message ? error.message : 'Add to cart failed'
          }
        }));
        return false;
      })
      .then(function(result) {
        releaseButton();
        return result;
      });
  }

  // Shared helper consumed by related-products and collection/featured sections.
  if (typeof window.tfxOverlayAddToCart !== 'function') {
    window.tfxOverlayAddToCart = addOverlayItemToCart;
  }

  function bindFeaturedCollectionEditorEvents() {
    if (overlayRefreshState.featuredListenersBound) { return; }

    document.addEventListener('shopify:section:load', function(event) {
      if (!event.detail || !event.detail.sectionId) { return; }
      window.tfxInitFeaturedCollectionPresentation(event.detail.sectionId);
    });

    document.addEventListener('shopify:section:select', function(event) {
      if (!event.detail || !event.detail.sectionId) { return; }
      window.tfxInitFeaturedCollectionPresentation(event.detail.sectionId);
    });

    overlayRefreshState.featuredListenersBound = true;
  }

  function bindFeaturedCollectionResizeSync() {
    if (overlayRefreshState.featuredResizeListenerBound) { return; }

    var resizeFrame = null;
    window.addEventListener('resize', function() {
      if (resizeFrame !== null) { return; }
      resizeFrame = requestAnimationFrame(function() {
        resizeFrame = null;
        syncAllFeaturedCollectionCentering();
      });
    }, { passive: true });

    overlayRefreshState.featuredResizeListenerBound = true;
  }

  function bindCollectionOverlayReinit() {
    if (!isCollectionContext()) { return; }

    var observerTargets = getCollectionObserverTargets();
    if (!observerTargets.length) {
      if (overlayRefreshState.observer) {
        overlayRefreshState.observer.disconnect();
        overlayRefreshState.observer = null;
      }
      return;
    }

    if (overlayRefreshState.observer) {
      overlayRefreshState.observer.disconnect();
    }

    overlayRefreshState.observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutationTouchesRelevantZone(mutations[i])) {
          debounceReinit();
          break;
        }
      }
    });

    observerTargets.forEach(function(targetNode) {
      overlayRefreshState.observer.observe(targetNode, { childList: true, subtree: true });
    });

    if (!overlayRefreshState.collectionListenersBound) {
      overlayRefreshState.collectionEditorReinitHandler = function() {
        debounceReinit();
        bindCollectionOverlayReinit();
      };
      document.addEventListener('shopify:section:load', overlayRefreshState.collectionEditorReinitHandler);
      document.addEventListener('shopify:section:select', overlayRefreshState.collectionEditorReinitHandler);
      document.addEventListener('shopify:section:unload', overlayRefreshState.collectionEditorReinitHandler);
      document.addEventListener('shopify:section:reorder', overlayRefreshState.collectionEditorReinitHandler);
      overlayRefreshState.collectionListenersBound = true;
    }

    reinitCollectionOverlays();
  }

  function boot() {
    bindFeaturedCollectionEditorEvents();
    bindFeaturedCollectionResizeSync();
    reinitFeaturedCollectionPresentations();
    bindCollectionOverlayReinit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
/* END TFX_COLLECTION_OVERLAY_REFRESH */
